<script setup lang="ts">
const { article } = defineProps<{
  article: CrystallizeArticle
}>()

provide(diKeys.article, computed(() => article))

const template = computed(() => article.components?.template?.value)

const description = computed(() => getTextContent(article?.components?.leadParagraph))
const articleTags = article.components?.theme?.map(it => it.value)
const articleAuthors = article.components?.authorsChoice?.reduce<string[]>(
  (acc, curr) => {
    if (curr.type === 'author' && curr.value.name) {
      return [...acc, curr.value.name]
    }

    return acc
  },
  [],
)

useSeoMeta({
  ogType: 'article',
  description,
  ogDescription: description,
  ogImage: article.components?.headerImage
    ? {
        url: article.components.headerImage.url,
        alt: article.components.headerImage.altText || undefined,
      }
    : undefined,
  articlePublishedTime: article.components?.published?.toISOString(),
  // An empty array renders an empty article:tag or article:author meta.
  articleTag: articleTags?.length ? articleTags : undefined,
  articleAuthor: articleAuthors?.length ? articleAuthors : undefined,
})
</script>

<template>
  <article class="flex flex-col gap-10 md:gap-20 pt-5 pb-15">
    <div class="w-screen overflow-hidden">
      <NettbutikkArticleHeader />
    </div>
    <NettbutikkArticleBody class="mx-auto max-w-[min(calc(theme(screens.2xl)+50px),calc(100%-theme(spacing.m)))]" />
    <NettbutikkArticleRelatedArticles v-if="template !== 'info-page'" />
  </article>
</template>
